import { Fragment } from "react";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import UserNavBar from "src/Components/Custom/UserNavBar/UserNavBar";
import ContactUsContent from "./ContactUsContent";

function AuthContactUs() {
  return (
    <Fragment>
      <UserNavBar />
      <ContactUsContent />
      <Footer />
      <CopyRight />
    </Fragment>
  )
}
export default AuthContactUs;
